/**
* 酒店管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>酒店管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.name" placeholder="输入酒店名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="hotelAdd()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small"  :data="hotelData" highlight-current-row v-loading="loading"  border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="left" sortable prop="name" label="酒店名称" min-width="150"/>
      <el-table-column align="left" sortable prop="address" label="酒店地址" width="240" :formatter="contentFormat"/>
      <el-table-column align="left" sortable prop="level" label="酒店等级" min-width="90">
        <template slot-scope="scope">
          {{computedSiteType(scope.row.level)}}
        </template>
      </el-table-column>
      <el-table-column align="left" sortable prop="tel" label="电话" min-width="100"/>
      <el-table-column align="left" sortable prop="hotelManager" label="店长" width="100"/>
      <el-table-column align="left" sortable prop="discount" label="折扣比例" width="100"/>
      <el-table-column align="left" sortable prop="commission" label="佣金比例" width="100"/>
      <el-table-column align="left" sortable prop="hotelManagers" label="订单操作员" width="120"/>
      <el-table-column align="left" sortable prop="status" label="状态" min-width="60">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status=='1'?nshow:fshow" active-color="#13ce66" inactive-color="#ff4949" @change="changeHotelStatus(scope.$index, scope.row)">
          </el-switch>
        </template>
      </el-table-column>
     <!-- <el-table-column align="center" sortable prop="updateTime" label="修改时间" min-width="120">
        <template slot-scope="scope">
          <div>{{ scope.row.updateTime|timestampToTime }}</div>
        </template>
      </el-table-column>-->
      <el-table-column label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="hotelEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="hotelDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 新增编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="100%" @close='closeDialog("edit")'>
      <el-form label-width="95px" ref="editForm" :model="editForm" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="酒店名称" prop="name">
                <el-input size="small" v-model="editForm.name" placeholder="请输入酒店完整全称"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="店长" prop="hotelManager">
                <el-input size="small" style="width: 220px;"  v-model="editForm.hotelManager" placeholder="店长"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="电话" prop="tel">
                <el-input  size="small" style="width: 220px;" v-model="editForm.tel" placeholder="请输入联系电话，便于用户订房后联系酒店确认"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="酒店地址" prop="address">
                <el-input size="small" v-model="editForm.address" placeholder="请输入酒店地址"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="星级" prop="level">
                <el-select v-model="editForm.level" placeholder="请选择">
                  <el-option
                    v-for="item in levelInfo"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="平台价折扣" prop="discount">
                <el-input-number v-model="editForm.discount" :min="1" :max="20" label="折扣"></el-input-number>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="入住时间" prop="level">
                <el-time-select
                  v-model="editForm.checkInTime"
                  :picker-options="{
                  start: '00:00',
                  step: '00:60',
                  end: '24:00'
                  }" placeholder="最早入住时间">
                </el-time-select>
              </el-form-item>
            </div>
          </el-col>
          
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="佣金比例" prop="commission">
                <el-input-number v-model="editForm.commission" :min="0" :max="100" :step="0.1" label="佣金比例"></el-input-number>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="订单操作员"   prop="hotelManagers">
                <el-select v-model="editForm.hotelManagers" multiple filterable placeholder="请选择">
                  <el-option
                    v-for="item in mangerNames"
                    :key="item.userName"
                    :label="item.realName"
                    :value="item.userName">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="地铁站" prop="checkboxGroup1">
                  <el-checkbox-group v-model="editForm.checkboxGroup1" size="mini" >
                    <el-checkbox-button v-for="key in keywords1" :label="key" :key="key">{{key}}</el-checkbox-button>
                  </el-checkbox-group>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="商圈" prop="checkboxGroup2">
                <el-checkbox-group v-model="editForm.checkboxGroup2" size="mini">
                  <el-checkbox-button v-for="key in keywords2" :label="key" :key="key">{{key}}</el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="火车站" prop="checkboxGroup5">
                <el-checkbox-group v-model="editForm.checkboxGroup5" size="mini">
                  <el-checkbox-button v-for="key in keywords5" :label="key" :key="key">{{key}}</el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="汽车站" prop="checkboxGroup3">
                <el-checkbox-group v-model="editForm.checkboxGroup3" size="mini">
                  <el-checkbox-button v-for="key in keywords3" :label="key" :key="key">{{key}}</el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item>
              <el-upload
                class="upload-demo"
                action="/api/business/image/uploadImage"
                accept="image/jpeg,image/jpg,image/png"
                multiple
                :on-remove="handleRemove"
                :http-request="UploadFile"
                :file-list="editForm.fileList"
                list-type="picture-card">
                <el-button size="small" type="primary">上传图片</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpeg/jpg/png文件</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入请求方法
import {
  hotelList,
  hotelSave,
  hotelEdit,
  hotelDelete,
  hotelStatusEdit,
  DicGet,
  hotelManger
} from '../../api/hotelMg'
import Pagination from '../../components/Pagination'
import {roomStatusEdit} from "../../api/roomMg";
export default {
  data() {
    // 请求数据参数
    return {
      keywords1: [],
      keywords2: [],
      keywords3: [],
      keywords5: [],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: '添加酒店信息',
      editFormVisible: false, //控制编辑页面显示与隐藏
      dataAccessshow: false, //控制数据权限显示与隐藏
      levelInfo: [
        {
          value: "3",
          label: "三星及以下"
        }, {
          value: "4",
          label: "四星"
        }, {
          value: "5",
          label: "五星"
        }
      ],
      // 编辑与添加
      editForm: {
        id: '',
        name: '',
        address: '',
        remark: '',
        level: '',
        tel: '',
        discount: 10,
        hotelManager:'',
        hotelManagers:[],
        fileList: [],
        checkboxGroup1: [],
        checkboxGroup2: [],
        checkboxGroup3: [],
        checkboxGroup5: [],
        checkInTime:'',
        commission:10,//酒店佣金比例
        token: localStorage.getItem('logintoken')
      },
      formInline: {
        pageNum: 1,
        pageSize: 10,
        name: ''
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      //列表数据
      hotelData: [],
      //酒店管理员
      mangerNames:[],
      rules: {
        name: [ {required: true, message: '请输入酒店完整全称', trigger: 'blur'}],
        tel: [{required: true, message: '请输入联系电话，便于用户订房后联系酒店确认', trigger: 'blur'}],
        address: [ {required: true, message: '请输入酒店地址', trigger: 'blur'}],
        hotelManagers:[{required: true, message: '请选择酒店操作员', trigger: 'blur'}],
        remark: [{required: true, message: '请选择酒店详情', trigger: 'blur'}],
        checkInTime: [{required: true, message: '请选择入住时间', trigger: 'blur'}],
        commission: [{required: true, message: '请设置酒店佣金比例', trigger: 'blur'}]
      },
      fileList: []
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  computed:{
    computedSiteType(){
      return function(level){
        if(level){
         return  this.levelInfo[level-3]['label']
        }
      }
    }
  },
  /**
   * 数据发生改变
   */
  watch: {},
  /**
   * 创建完毕,初始化数据
   */
  created() {
    this.getdata(this.formInline)
    this.queryHotelKeywords()
    this.queryMangers()
  },
  methods: {
    getdata(parameter) {
      //获取酒店列表
      hotelList(parameter).then(res => {
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.message
          })
        } else {
          this.hotelData = res.result.rows
          // 分页赋值
          this.pageparm.currentPage = res.result.pagination.current
          this.pageparm.pageSize = res.result.pagination.pageSize
          this.pageparm.total = res.result.pagination.total
        }
      })
    },
    queryHotelKeywords:function(){
      DicGet('hotelKeywords').then(res =>{
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.message
          })
        } else {
          res.result.forEach(item =>{
            if (item.parentId==2){
              this.keywords1.push(item.name);
            }else if(item.parentId==14){
              this.keywords2.push(item.name);
            }else if(item.parentId==32){
              this.keywords3.push(item.name);
            }else if(item.parentId==38){
              this.keywords5.push(item.name);
            }
          })
        }
      })
    },
    queryMangers:function(){
      //酒店管理员
      hotelManger('2').then(res=>{
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.message
          })
        } else {
          res.result.forEach(item =>{
            this.mangerNames.push(item);
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: res.message
        })
      })
    },
    //搜索事件
    search() {
      this.getdata(this.formInline)
    },
    hotelAdd: function (index, row) {
      this.editFormVisible = true
      this.title = '添加酒店信息'
      this.editForm.id = ''
      this.editForm.name = ''
      this.editForm.address = ''
      this.editForm.tel = ''
      this.editForm.remark = ''
      this.editForm.level = ''
      this.editForm.discount=10
      this.editForm.commission=10
      this.editForm.hotelManager=''
      this.editForm.hotelManagers=[]
      this.editForm.checkboxGroup1=[]
      this.editForm.checkboxGroup2=[]
      this.editForm.checkboxGroup3=[]
      this.editForm.checkboxGroup5=[]
      this.editForm.checkInTime =''
    },
    // 选择复选框事件
    selectChange(val) {
      this.selectdata = val
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    UploadFile(param) {
      var data = new FormData();
      data.append("file", param.file);
      var config = {
        headers: {'Content-Type': 'multipart/form-data', token: localStorage.getItem('logintoken')}
      }
      this.$axios.post(param.action, data, config).then((res) => {
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.message
          })
        } else {
          //数组只赋值字符串url，无法自动传教uid，删除时无法处理，此处传对象
          let obj = new Object();
          obj.url="https://hotel.leikl.com/images/"+res.data.result;
          this.editForm.fileList.unshift(obj);
        }
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      }
      this.editForm.fileList=[]
      this.editForm.checkboxGroup1=[]
      this.editForm.checkboxGroup2=[]
      this.editForm.checkboxGroup3=[]
      this.editForm.checkboxGroup5=[]
      this.editForm.hotelManagers=[]
    },
    handleRemove(file) {
        let index= this.editForm.fileList.findIndex(fileItem =>{
          return fileItem.uid === file.uid;
        });
        this.editForm.fileList.splice(index,1);
    },
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.fileList){
            let newFileList = this.editForm.fileList.map(obj=>{return obj.url})
            this.editForm.fileList = newFileList;
          }
          if (this.editForm.id == undefined || this.editForm.id.length <= 0) {
            //图片数组对象处理,只取url丢到后台

            // 新增酒店信息
            hotelSave(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.success) {
                  this.getdata(this.formInline)
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  })
                  this.$refs['editForm'].resetFields();
                } else {
                  this.$message({
                    type: 'info',
                    message: res.message
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          } else {
            hotelEdit(this.editForm)
              .then(res => {
                this.editFormVisible = false
                //this.loading = false
                if (res.success) {
                  this.getdata(this.formInline)
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.message
                  })
                }
              })
          }
        } else {
          return false
        }
      })
    },
    // 删除酒店信息
    hotelDelete(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除
        hotelDelete({ids: row.id})
          .then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '数据已删除!'
              })
              this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'info',
                message: res.message
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('数据删除失败，请稍后再试！')
          })
      })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },
    hotelEdit: function (index, row) {
      this.editFormVisible = true;
      this.title = '修改酒店信息';
      this.editForm.id = row.id;
      this.editForm.name = row.name;
      this.editForm.address = row.address;
      this.editForm.tel = row.tel;
      this.editForm.phone = row.phone;
      this.editForm.remark = row.remark;
      this.editForm.level = row.level;
      this.editForm.discount = row.discount;
      this.editForm.hotelManager = row.hotelManager;
      this.editForm.checkInTime = row.checkInTime;
      this.editForm.commission = row.commission;
      //管理员

      if(row.hotelManagers!=null && row.hotelManagers.length>0){
        row.hotelManagers.forEach(item=>{
          this.editForm.hotelManagers.push(item);
        })
      }
      if(row.hotelKeywords!=null && row.hotelKeywords.length>0){
        row.hotelKeywords.forEach(item=>{
          //如果不在keyword1数据中则剔除
          if(this.keywords1.includes(item)){
            this.editForm.checkboxGroup1.push(item);
          }
          if(this.keywords2.includes(item)){
            this.editForm.checkboxGroup2.push(item);
          }
          if(this.keywords3.includes(item)){
            this.editForm.checkboxGroup3.push(item);
          }
          if(this.keywords5.includes(item)){
            this.editForm.checkboxGroup5.push(item);
          }
        })
      }
      if (row.fileList != null && row.fileList.length > 0){
        row.fileList.forEach(item=>{
          let obj = new Object();
          obj.url = "https://hotel.leikl.com/images/"+item;
          this.editForm.fileList.push(obj);
        })
      }
    },
    changeHotelStatus: function(index, row) {
      this.loading = true
      let parm = {
        status: '',
        id: '',
        token: localStorage.getItem('logintoken')
      }
      parm.id = row.id
      let status = row.status
      if (status == '1') {
        parm.status = '2'
      } else {
        parm.status = '1'
      }
      // 修改状态
      hotelStatusEdit(parm).then(res => {
        this.loading = false
        if (!res.success) {
          this.$message({
            type: 'info',
            message: res.message
          })
        } else {
          this.getdata(this.formInline)
          this.$message({
            type: 'success',
            message: '状态修改成功'
          })
          this.getdata(this.formInline)
        }
      })
    },
    contentFormat(row,column,callValue){
      if(!callValue){
        return ""
      }
      if(callValue.length>15){
        return callValue.slice(0,15)+"..."
      }
      return callValue
      }
    }
  }
</script>

<style scoped>
.search {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/hotel/Hotel.vue